import styled from 'styled-components'

export default styled.div`
  .rider-details--container {
    background: #272B4A;
    border-radius: 8px;
    max-width: 700px;
    margin: 0 auto;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);

    header {
      padding: 1.5rem 2rem;
      background: #272B4A;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        font-size: 1.25rem;
        margin: 0;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
      }

      .close--btn {
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.6);
        font-size: 1.5rem;
        width: 32px;
        height: 32px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: all 0.2s;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }

    .tabs--container {
      display: flex;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.2);

      .tab {
        flex: 1;
        padding: 1rem;
        background: none;
        border: none;
        border-bottom: 2px solid transparent;
        font-size: 0.875rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          color: rgba(255, 255, 255, 0.9);
          background: rgba(255, 255, 255, 0.05);
        }

        &.active {
          color: ${({ theme }) => theme.primary};
          border-bottom-color: ${({ theme }) => theme.primary};
          background: #272B4A;
        }
      }
    }

    .details--content {
      padding: 1.5rem 2rem;
      min-height: 300px;
      max-height: 500px;
      overflow-y: auto;

      .tab-content {
        animation: fadeIn 0.3s ease;
      }

      .detail--row {
        padding: 1rem 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        &:last-child {
          border-bottom: none;
        }

        label {
          font-size: 0.8125rem;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.6);
          text-transform: uppercase;
          letter-spacing: 0.025em;
          display: block;
          margin-bottom: 0.375rem;
        }

        p {
          font-size: 0.9375rem;
          color: rgba(255, 255, 255, 0.9);
          margin: 0;

          &.status {
            display: inline-block;
            padding: 0.4em 1em;
            border-radius: 20px;
            font-size: 0.8rem;
            font-weight: 600;
            text-transform: uppercase;

            &.active {
              background: #6ABA6D;
              color: #fff;
            }

            &.inactive {
              background: #ef4444;
              color: #fff;
            }
          }
        }
      }

      .actions-tab {
        .action--card {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.25rem;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          margin-bottom: 1rem;
          transition: all 0.2s;
          background: rgba(255, 255, 255, 0.03);

          &:hover {
            border-color: rgba(255, 255, 255, 0.2);
            transform: translateY(-2px);
          }

          &.danger {
            border-color: rgba(239, 68, 68, 0.3);
            background: rgba(239, 68, 68, 0.1);
          }

          .action--info {
            flex: 1;

            h4 {
              font-size: 1rem;
              font-weight: 600;
              color: rgba(255, 255, 255, 0.9);
              margin: 0 0 0.25rem 0;
            }

            p {
              font-size: 0.875rem;
              color: rgba(255, 255, 255, 0.6);
              margin: 0;

              strong {
                color: rgba(255, 255, 255, 0.9);
              }
            }
          }

          button {
            padding: 0.5rem 1rem;
            border-radius: 6px;
            font-size: 0.875rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            white-space: nowrap;
            cursor: pointer;
            border: none;

            &.btn-status {
              background: #f39c12;
              color: #fff;

              &:hover {
                opacity: 0.9;
              }
            }

            &.btn-edit {
              background: ${({ theme }) => theme.primary};
              color: #fff;

              &:hover {
                opacity: 0.9;
              }
            }

            &.btn-delete {
              background: #ef4444;
              color: #fff;

              &:hover {
                opacity: 0.9;
              }
            }
          }
        }

        .delete-confirm {
          background: rgba(239, 68, 68, 0.1);
          border: 2px solid rgba(239, 68, 68, 0.3);
          border-radius: 8px;
          padding: 1.5rem;
          margin-top: 1rem;

          p {
            font-size: 0.9375rem;
            color: rgba(255, 255, 255, 0.9);
            margin: 0 0 0.5rem 0;

            &.warning {
              font-size: 0.8125rem;
              color: #ef4444;
              font-weight: 500;
            }
          }

          .confirm-actions {
            display: flex;
            gap: 0.75rem;
            margin-top: 1rem;

            button {
              flex: 1;
              padding: 0.625rem 1rem;
              border-radius: 6px;
              font-size: 0.875rem;
              font-weight: 500;
              border: none;
              cursor: pointer;

              &.btn-cancel {
                background: rgba(255, 255, 255, 0.1);
                color: rgba(255, 255, 255, 0.9);

                &:hover {
                  background: rgba(255, 255, 255, 0.15);
                }
              }

              &.btn-confirm-delete {
                background: #ef4444;
                color: #fff;

                &:hover {
                  opacity: 0.9;
                }
              }
            }
          }
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    .rider-details--container {
      max-width: 100%;

      .tabs--container {
        .tab {
          font-size: 0.8125rem;
          padding: 0.875rem 0.5rem;
        }
      }

      .details--content {
        .actions-tab {
          .action--card {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;

            button {
              width: 100%;
              justify-content: center;
            }
          }
        }
      }
    }
  }
`
